



































































































































































































import Loading from 'vue-loading-overlay';
import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper, AuthStoreHelper } from '../../core/mixins';
import { FilterDateEvent, ID } from '../../core/utils/types';
import { getDateFromDateFormatApi, getIndexFromList, itemsPerPageOptionsTable, NAME_ROUTES, PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
import { PageTitle } from '../../core/components';
import { RecipientDialog } from '../components';
import Combobox from '../../core/components/Combobox.vue';
import { Recipient, RecipientToAdd } from '../models/Recipient';
import { SettingsService } from '../api/SettingsService';
import Input from '../../core/components/Input.vue'; 
import { SuscriptionRecipients } from '../../reports/models';
import vColumnsResizable from '../../../plugins/vue-columns-resizable'
@Component({
    directives: {
        'v-columns-resizable': vColumnsResizable,
    },
    components: { Loading, RecipientDialog, PageTitle, Input, Combobox }
})
export default class RecipientsPage extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    AuthStoreHelper
) {
    @Prop({ default: false }) isModal: boolean;
    @Prop({
        default() {
            return [];
        }
    })
    itemsPerPageOptions: Array<number> = itemsPerPageOptionsTable;
    companiesFromReports;
    cancelToken: any | null = null;
    showConfigurationDialog: boolean = false;
    pendingRequest: boolean = true;
    search: string = '';
    showRecipientDialog: boolean = false;
    companyRV: boolean = false;
    ids: number = 4;
    editing: boolean = false;
    recipientToEdit: any | null = null;
    recipientToDelete: any | null = null;
    filtersCompanySelected: any | null = null;
    defaultSortBy: string[] = ['name'];
    defaultSortDesc: boolean[] = [false];
    sortBy: string[] = this.defaultSortBy;
    sortDesc: boolean[] = this.defaultSortDesc;
    availabilityFilterValue: any = 'null';
    availabilityList: any = [
        {
            text: 'Activos',
            value: 'true'
        },
        {
            text: 'Inactivos',
            value: 'false'
        },
        {
            text: 'Todos',
            value: 'null'
        }
    ];

    updateCompanySelected(currentFilter) {
        this.filtersCompanySelected = currentFilter;
        this.updateRecipientsByCompany(currentFilter);
    }
    updateCompanyRV(value) {
        this.filtersCompanySelected = value;
    }

    updateRecipientsByCompany(currentFilter) {
        if (currentFilter == null) {
            this.recipients = this.allRecipients;
        } else {
            this.recipients = [...this.allRecipients].filter(function(item) {
                let indexInCompanies = item['companies'].findIndex(item => item['id'] == currentFilter['id']);
                if (indexInCompanies !== -1) {
                    return item;
                }
            });
        }
    }

    availabilityFilter(value) {
        if (this.availabilityFilterValue == 'null') {
            return true;
        }
        return value.toString() === this.availabilityFilterValue;
    }

    showSelectedRecipientsFirst() {
        //add selected key to selected indexes
        let self = this;
        this.recipients = this.recipients.map(function(recipient) {
            let recipientToReturn: any = {
                ...recipient,
                isSelected: false
            };
            let indexInSelectedOnes = self.selectedItems.findIndex(item => item['id'] == recipient['id']);
            if (indexInSelectedOnes !== -1) {
                recipientToReturn['isSelected'] = true;
            }
            return recipientToReturn;
        });
    }

    deleteConfirmationTitle: string = 'Eliminar Destinatarios';
    deleteConfirmationMessage: string =
        '¿Está seguro que desea eliminar los destinatarios seleccionados? Esta acción no se podrá deshacer.';

    showDeleteConfirmationDialog: boolean = false;


    closeDeleteConfirmationDialog(confirm: boolean) {
        if (confirm) {
            this.pendingRequest = true;
            this.cancelToken = Axios.CancelToken.source();
            let ids: number[] = [];
            if (this.recipientToDelete !== null) {
                ids.push(this.recipientToDelete['id']);
            } else {
                for (let i = 0; i < this.selectedItems.length; i++) {
                    ids.push(this.selectedItems[i].id);
                }
            }

            SettingsService.deleteRecipientsByID(ids, this.cancelToken)
                .then(() => {
                    this.selectedItems = [];
                    this.$_successDeleteRecipients('Destinatario/s eliminado/s con éxito.');
                    this.pendingRequest = false;
                    this.updateRecipientsList(ids);
                    this.recipientToDelete = null;
                })
                .catch(() => {
                    this.$_errorDeleteRecipients('Error al intentar eliminar destinatario/s.');
                    this.pendingRequest = false;
                    this.recipientToDelete = null;
                });
        }
        this.showDeleteConfirmationDialog = false;
    }

    resetFilters() {
        this.search = '';
        this.availabilityFilterValue = 'null';
        this.updateCompanySelected(null);
        // localStorage.removeItem('driverListFilters');
    }

    updateRecipientsList(idsToRemove: number[]) {
        for (let index = 0; index < idsToRemove.length; index++) {
            const currentId = idsToRemove[index];
            let indexInRecipientList = getIndexFromList(this.recipients, 'id', currentId);
            if (indexInRecipientList !== -1) {
                this.recipients.splice(indexInRecipientList, 1);
            }
        }
    }

    deleteSelectedItems() {
        this.showDeleteConfirmationDialog = true;
    }

    deleteRecipient(recipient) {
        this.recipientToDelete = recipient;
        this.deleteSelectedItems();
    }

    getTitleFromCompanies(companies) {
        if (!Array.isArray(companies)) {
            return '';
        } else {
            return companies
                .map(cpny => {
                    return cpny.name;
                })
                .join(', ');
        }
    }

    volverAConfiguracion() {
        this.$router.push(NAME_ROUTES.SETTINGS.path);
    }

    headers: Array<object> = [
        {
            text: 'Nombre',
            align: 'center',
            value: 'name'
        },
        {
            text: 'Teléfono',
            value: 'phone_number'
        },
        {
            text: 'Compañías',
            value: 'companies',
            width: '300px'
        },
        {
            text: 'Correo Electrónico',
            value: 'mail'
        },
        {
            text: 'Activo',
            value: 'active',
            filter: this.availabilityFilter
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        }
    ];
    companiesInList: any = [];
    allRecipients: Recipient[] = [];
    recipients: Recipient[] = [];
    selectedItems: Recipient[] = [];

    clearSelectedItems() {
        this.selectedItems = [];
    }

    addItem() {
        this.showRecipientDialog = true;
        this.editing = false;
    }

    closeRecipientDialog(action: boolean, recipient: any) {
        if (action) {
            this.getRecipientsList();
        }
        this.recipientToDelete = null;
        this.showRecipientDialog = false;
        this.editing = false;
    }

    editSelectedItem(recipientToEdit) {
        let recipient = recipientToEdit == null ? this.selectedItems[0] : recipientToEdit;
        this.selectedItems = [];
        this.recipientToEdit = {
            id: recipient.id,
            name: recipient.name,
            phone_number: recipient.phone_number,
            mail: recipient.mail,
            active: recipient.active,
            companies: recipient.companies,
            report_subscription: recipient.report_subscription
        };
        this.editing = true;
        this.showRecipientDialog = true;
    }

    selectRecipients(recipients: Array<SuscriptionRecipients>) {
        this.resetFilters();
        this.clearSelectedItems();
        for (let index = 0; index < recipients.length; index++) {
            const currentId = recipients[index].id;
            let indexEmailInRecipientsList = this.recipients.findIndex(item => item['id'] == currentId);
            if (indexEmailInRecipientsList !== -1) {
                this.selectedItems.push(this.recipients[indexEmailInRecipientsList]);
            }
        }
    }

    checkPermissions() {
        if (!this.shouldReadRecipients) {
            this.$router.push(NAME_ROUTES.HOME.path);
        }
    }

    get shouldCreateRecipients(): boolean {
        return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.DRIVERS, PRIVILEGE_TYPES.CREATE)
        );
    }

    get shouldReadRecipients(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.RECIPIENTS, PRIVILEGE_TYPES.READ);
    }

    get shouldEditAndDelete(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.RECIPIENTS, PRIVILEGE_TYPES.EDIT_AND_DELETE);
    }

    updateSort() {
        if (this.selectedItems.length == 0) {
            this.sortBy = this.defaultSortBy;
            this.sortDesc = this.defaultSortDesc;
        } else {
            this.sortBy = ['isSelected'];
            this.sortDesc = [true];
        }
    }
    getRecipients() {
        let ids = [this.$_getSelectedCompanyById as string];
        SettingsService.getRecipientsList(ids, false, this.cancelToken)
            .then(data => {
                this.setRecipientsList(data);
                this.updateSort();
                this.pendingRequest = false;
            })
            .catch(err => {
                this.$_errorGetRecipients('Error al obtener destinatarios.');
                this.pendingRequest = false;
            });
    }

    setRecipientsList(data) {
        let self = this;
        if (data.length !== 0) {
            data = data.map(function(item) {
                self.companiesInList = [...self.companiesInList, ...item['companies']];
                return {
                    ...item,
                    isSelected: false
                };
            });
        }

        self.companiesInList = [...new Map(self.companiesInList.map(item => [item['id'], item])).values()];
        this.allRecipients = data;
        this.recipients = data;
    }

    @Watch('$_getSelectedCompany')
    getRecipientsList() {
        this.pendingRequest = true;
        this.cancelToken = Axios.CancelToken.source();
        if (this.$_getSelectedCompanyById != null) {
            this.getRecipients();
        }
    }

    clearFilter() {
        this.availabilityFilterValue = 'null';
    }

    updateSearchValue(value){
        this.search = value;
    }

    mounted() {
        this.getRecipientsList();
    }
}
